import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { DisciplineView } from '@/module/Discipline/DisciplineView';
import { getDisciplineOptions } from '@/module/Discipline/model/DisciplineQuery';

export const Route = createFileRoute(
  '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { disciplineId } = Route.useParams();
  const { data: discipline } = useSuspenseQuery(getDisciplineOptions(disciplineId));

  return <DisciplineView discipline={discipline} />;
}
